import { Pipe, PipeTransform } from '@angular/core';
import { eroiService } from '../services/eroi-metric.service';
import { UomOption } from 'src/app/core/services/currency-uom.service';

interface TitleOptions {
  showInEnterpriseTerms?: boolean;
}

interface UnitsOptions {
  measurementSystem?: UomOption; // TODO: Use UnitOfMeasureTypes (generated code from swagger.json), which should be renamed to MeasurementSystem in the API.
}

type EroiPipeOptions = TitleOptions & UnitsOptions;

type EroiPipeMode =
     'title' |
     'units' |
     'grayIcon' |
     'metricIcon' |
     'summaryPillIcon' |
     'impactIcon' |
     'summaryPillTitle';

@Pipe({
    name: 'eroi',
    pure: true,
    standalone: false
})
export class EroiPipe implements PipeTransform {

  constructor(private eroiService: eroiService) {}

  transform(
    value: string | undefined,
    mode: EroiPipeMode,
    options?: EroiPipeOptions
  ): string {

    if (!value) {
      return '';
    }

    switch (mode) {
      case 'title':
        return options?.showInEnterpriseTerms ? this.eroiService.mapIdToEnterpriseTermsTitle(value) : this.eroiService.mapIdToTitle(value);

      case 'units':
        return this.eroiService.mapIdToUnits(value, options?.measurementSystem);

      case 'grayIcon':
        return this.eroiService.mapIdToGrayIconPath(value);

      case 'metricIcon':
        return this.eroiService.mapIdToMetricIconPath(value);

      case 'summaryPillIcon':
        return this.eroiService.mapIdToNeptuneSummaryPillIconPath(value);

      case 'impactIcon':
        return this.eroiService.mapImpactCategoryToIconPath(value);

      case 'summaryPillTitle':
        return this.eroiService.mapEroiIdToSummaryPillTitle(value);

      default:
        return '';
    }
  }
}